import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-EDM-failure",
  "use": "icon-EDM-failure-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-EDM-failure\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0a512 512 0 1 1 0 1024 512 512 0 0 1 0-1024z m0 102.4a409.6 409.6 0 1 0 0 819.2A409.6 409.6 0 0 0 512 102.4z\" p-id=\"16858\" /><path d=\"M469.376 213.376v384h85.248v-384zM512 810.624a64 64 0 1 0 0-128 64 64 0 0 0 0 128z\" p-id=\"16859\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol